import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {POST_ADMIN_VERIFY_CANDIDATE_URL, POST_VERIFY_CANDIDATE_URL,} from '../../constants/apiUrls';
import {useCustomMutation} from '../utils/useCustomMutation';
import {CreateCandidateRequest} from './usePostCreateCandidate';
import {GenericErrorResponse} from "../typings";
import {Dayjs} from "dayjs";

// =============================================================================
// Response Model
// =============================================================================

export interface VerifyCandidateRequest {
  candidateName: string | null;
  userIdentityNumber: string | null;
  userIdType: string | null;
  organisationName: null;
  organisationUuid?: string;
  dateOfBirth?: string | null;
}

// =============================================================================
// Mutation
// =============================================================================

interface Input {
  onSuccess?: (data: CreateCandidateRequest) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostVerifyCandidate = ({onSuccess, onError}: Input = {}) => {
  const postVerifyCandidate = async (
      reqBody: VerifyCandidateRequest
  ): Promise<CreateCandidateRequest> => {
    const res = await axiosClient.post<CreateCandidateRequest>(POST_VERIFY_CANDIDATE_URL, reqBody, {
      timeout: 65000,
    });
    return res.data;
  };

  return useCustomMutation(
      postVerifyCandidate,
      {
        onSuccess,
        onError,
      },
      false,
      false
  );
};

export const usePostVerifyCandidateByOpsAdmin = ({onSuccess, onError}: Input = {}) => {
  const postVerifyCandidate = async (
      reqBody: VerifyCandidateRequest
  ): Promise<CreateCandidateRequest> => {
    const res = await axiosClient.post<CreateCandidateRequest>(
        POST_ADMIN_VERIFY_CANDIDATE_URL,
        reqBody
    );
    return res.data;
  };

  return useCustomMutation(
      postVerifyCandidate,
      {
        onSuccess,
        onError,
      },
      false
  );
};
